<script setup lang="ts">
import i18n from '@/lang/i18n';
</script>

<template>
  <tr class="table-header">
    <td rowspan="2">
      {{ i18n.global.t('pages.monthlyReportWorkingTimesSetting.header.date') }}
    </td>
    <td rowspan="2">
      {{ i18n.global.t('pages.monthlyReportWorkingTimesSetting.header.dayOfWeek') }}
    </td>
    <td rowspan="2">
      {{ i18n.global.t('pages.monthlyReportWorkingTimesSetting.header.startWork') }}
    </td>
    <td rowspan="2">
      {{ i18n.global.t('pages.monthlyReportWorkingTimesSetting.header.endWork') }}
    </td>
    <td rowspan="2">
      {{ i18n.global.t('pages.monthlyReportWorkingTimesSetting.header.drivingTotalTime') }}
    </td>
    <td rowspan="2">
      {{ i18n.global.t('pages.monthlyReportWorkingTimesSetting.header.betweenEndAndStart') }}
    </td>
    <td rowspan="2">
      {{ i18n.global.t('pages.monthlyReportWorkingTimesSetting.header.mileage') }}
    </td>
    <td colspan="8">
      {{ i18n.global.t('pages.monthlyReportWorkingTimesSetting.header.restraintTime') }}
    </td>
    <td rowspan="2">
      {{ i18n.global.t('pages.monthlyReportWorkingTimesSetting.header.workTime') }}
    </td>
    <td rowspan="2">
      {{ i18n.global.t('pages.monthlyReportWorkingTimesSetting.header.duplicationTime') }}
    </td>
    <td colspan="3">
      {{ i18n.global.t('pages.monthlyReportWorkingTimesSetting.header.restPeriod') }}
    </td>
    <td rowspan="2">
      {{ i18n.global.t('pages.monthlyReportWorkingTimesSetting.header.overTime') }}
    </td>
    <td rowspan="2">
      {{ i18n.global.t('pages.monthlyReportWorkingTimesSetting.header.lateNightWorkingHours') }}
    </td>
  </tr>
  <tr class="table-header">
    <td>
      {{ i18n.global.t('pages.monthlyReportWorkingTimesSetting.header.driving') }}
    </td>
    <td>
      {{ i18n.global.t('pages.monthlyReportWorkingTimesSetting.header.break') }}
    </td>
    <td>
      {{ i18n.global.t('pages.monthlyReportWorkingTimesSetting.header.loading') }}
    </td>
    <td>
      {{ i18n.global.t('pages.monthlyReportWorkingTimesSetting.header.unloading') }}
    </td>
    <td>
      {{ i18n.global.t('pages.monthlyReportWorkingTimesSetting.header.shipping') }}
    </td>
    <td>
      {{ i18n.global.t('pages.monthlyReportWorkingTimesSetting.header.wait') }}
    </td>
    <td>
      {{ i18n.global.t('pages.monthlyReportWorkingTimesSetting.header.others') }}
    </td>
    <td>
      {{ i18n.global.t('pages.monthlyReportWorkingTimesSetting.header.sum') }}
    </td>
    <td>
      {{ i18n.global.t('pages.monthlyReportWorkingTimesSetting.header.start') }}
    </td>
    <td>
      {{ i18n.global.t('pages.monthlyReportWorkingTimesSetting.header.end') }}
    </td>
    <td>
      {{ i18n.global.t('pages.monthlyReportWorkingTimesSetting.header.total') }}
    </td>
  </tr>
</template>

<style scoped>
#trip-detail-table td {
  padding-top: 7px;
  padding-bottom: 7px;
  padding-left: 2px;
  padding-right: 2px;
  text-align: center;
  font-weight: bold !important;
  border: 1 !important;
  border-width: 2px !important;
}
#trip-detail-table .table-header {
  background-color: silver !important;
}
#trip-detail-table tr,
p {
  line-height: 15px;
  font-size: 13px;
  font-weight: bold;
}
</style>
